import { Tooltip } from "@mui/material";
import { FC } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  CreateAdIcon,
  MyAdDealsIcon,
  MyAdIcon,
  MyProfileIcon,
  NewReportIcon,
  RegisterIcon,
  ReportIcon,
} from "../../assets";

const SideNav: FC = ({ children }) => {
  const userRole = useSelector((state: any) => {
    return state.userReducer.user;
  });
  return (
    <>
      {/* container */}
      <aside
        className="flex flex-col items-center text-gray-700 shadow h-full sticky top-0 z-40 h-screen max-w-[60px] transition-all sm:w-auto max-w-0 hidden sm:block  sm:max-w-none"
        style={{ background: "#2E5242" }}
      >
        {/* Side Nav Bar*/}
        {/* <div className="h-16 flex items-center w-full place-content-center">
          <span className="text-2xl text-white font-extrabold text-center flex">
            D
          </span>
          <span className="text-xs text-white font-semibold text-center flex">
            -ADS
          </span>
        </div> */}
        <ul>
          {/* Items Section */}
          {/* {userRole == "New User" && ( */}
          <Link to="/">
            <li className="hover:bg-green-600">
              <Tooltip title="Register" placement="right">
                <a
                  href="."
                  className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                >
                  <img className="h-5 w-5" src={RegisterIcon} />
                </a>
              </Tooltip>
            </li>
          </Link>
          {/* )} */}
          {/* {userRole == "Voter" && ( */}
          <>
            <Link to="/all-dapps">
              <li className="hover:bg-green-600">
                <Tooltip title="Reported Dapps" placement="right">
                  <a
                    href="."
                    className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                  >
                    <img className="h-5 w-5" src={ReportIcon} />
                  </a>
                </Tooltip>
              </li>
            </Link>
            <Link to="/dapp-report">
              <li className="hover:bg-green-600">
                <Tooltip title="Report Dapp" placement="right">
                  <a
                    href="."
                    className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                  >
                    <img className="h-5 w-5" src={NewReportIcon} />
                  </a>
                </Tooltip>
              </li>
            </Link>
          </>
          {/* // )} */}
          <Link to="/create-ad-proposal">
            {" "}
            <li className="hover:bg-green-600">
              <Tooltip title="Create Ad" placement="right">
                <a
                  href="."
                  className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                >
                  <img className="h-5 w-5" src={CreateAdIcon} />
                </a>
              </Tooltip>
            </li>
          </Link>
          <Link to="/profile">
            <li className="hover:bg-green-600">
              <Tooltip title="My Profile" placement="right">
                <a
                  href="."
                  className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                >
                  <img className="h-5 w-5" src={MyProfileIcon} />
                </a>
              </Tooltip>
            </li>
          </Link>
          {/* {userRole == "DApp" && ( */}
          <>
            <Link to="/my-ad-deals">
              <li className="hover:bg-green-600">
                <Tooltip title="My Ad Deals" placement="right">
                  <a
                    href="."
                    className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                  >
                    <img className="h-5 w-5" src={MyAdDealsIcon} />
                  </a>
                </Tooltip>
              </li>
            </Link>
            <Link to="/my-ads">
              <li className="hover:bg-green-600">
                <Tooltip title="My Created Ads" placement="right">
                  <a
                    href="."
                    className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                  >
                    <img className="h-5 w-5" src={MyAdIcon} />
                  </a>
                </Tooltip>
              </li>
            </Link>
          </>
          {/* )} */}
          <Link to="/all-dapps">
            <li className="hover:bg-green-600">
              <Tooltip title="All Decentrads Applications" placement="right">
                <a
                  href="."
                  className="h-16 px-6 flex flex justify-center items-center w-full
					focus:text-orange-500"
                >
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
                    <path
                      d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0
							2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0
							0-1.79 1.11z"
                    />
                  </svg>
                </a>
              </Tooltip>
            </li>
          </Link>
        </ul>
      </aside>
      <div className="relative flex w-screen min-w-0 shrink-0 flex-col sm:w-auto sm:shrink sm:grow">
        {children}
      </div>
    </>
  );
};

export default SideNav;
